import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Domaine de production AVELIS — utilisé pour les URLs canoniques, og:url et og:image.
export const SITE_URL = "https://avelis.be";

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

const Seo = ({ title, description, jsonLd, ogImage = "/og-image.jpg" }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (title) document.title = title;
    const set = (selector, value) => {
      const el = document.head.querySelector(selector);
      if (el && value) el.setAttribute("content", value);
    };
    set('meta[name="description"]', description);
    set('meta[property="og:title"]', title);
    set('meta[property="og:description"]', description);
    set('meta[name="twitter:title"]', title);
    set('meta[name="twitter:description"]', description);

    if (SITE_URL) {
      const url = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
      upsert('link[rel="canonical"]', () => {
        const l = document.createElement("link");
        l.setAttribute("rel", "canonical");
        return l;
      }).setAttribute("href", url);
      upsert('meta[property="og:url"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:url");
        return m;
      }).setAttribute("content", url);
      const image = `${SITE_URL}${ogImage}`;
      upsert('meta[property="og:image"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:image");
        return m;
      }).setAttribute("content", image);
      upsert('meta[name="twitter:image"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "twitter:image");
        return m;
      }).setAttribute("content", image);
    }
  }, [title, description, pathname, ogImage]);

  useEffect(() => {
    if (!jsonLd) return;
    const items = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    const nodes = items.map((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "true");
      s.textContent = JSON.stringify(data);
      document.head.appendChild(s);
      return s;
    });
    return () => nodes.forEach((n) => n.remove());
  }, [jsonLd]);

  return null;
};

export default Seo;
